import { render, staticRenderFns } from "./BuyCardDetail.vue?vue&type=template&id=3e9dfb4c&scoped=true&"
import script from "./BuyCardDetail.vue?vue&type=script&lang=js&"
export * from "./BuyCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyCardDetail.vue?vue&type=style&index=0&id=3e9dfb4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9dfb4c",
  null
  
)

export default component.exports